export default __webpack_public_path__ + "static/0121-1ac1cf9d19cc1d37b0c9109b47f21f03.png";